import getDocumentExistsOffline from 'utils/getDocumentExistsOffline'

// Can only clone document if content is synced locally
export default async function canCloneDocument (userId, docId) {
  return getDocumentExistsOffline(docId)
}
